/* Délo POP theme script: flavor card size switch, product page purchase options,
   the build-a-box builder, and the copy-email button. Plain JavaScript, no libraries. */
/* phone box bar: a slim bar at the bottom of the screen shows how full the box is while the box summary is off screen */
(function () {
  window.deloBoxBar = function (section, sum) {
    if (!section || !sum || !window.IntersectionObserver) return { update: function () {} };
    var bar = document.createElement('div');
    bar.className = 'boxbar';
    bar.hidden = true;
    bar.innerHTML = '<div class="boxbar-track" aria-hidden="true"><i></i></div>' +
      '<div class="boxbar-row"><span class="bb-text">Your box · 0% full</span><span class="bb-total">$0.00</span>' +
      '<button type="button" class="btn pop sm bb-go">View box</button></div>';
    document.body.appendChild(bar);
    var fill = bar.querySelector('i'), text = bar.querySelector('.bb-text'), total = bar.querySelector('.bb-total'), go = bar.querySelector('.bb-go');
    var inSection = false, sumSeen = false;
    var mq = window.matchMedia ? window.matchMedia('(max-width: 860px)') : { matches: false };
    function show() { bar.hidden = !(mq.matches && inSection && !sumSeen); }
    new IntersectionObserver(function (es) { inSection = es[0].isIntersecting; show(); }).observe(section);
    new IntersectionObserver(function (es) { sumSeen = es[0].isIntersecting; show(); }, { threshold: 0.15 }).observe(sum);
    if (mq.addEventListener) mq.addEventListener('change', show);
    go.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      sum.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
    return {
      update: function (pct, totalText, isFull) {
        fill.style.width = pct + '%';
        text.textContent = isFull ? 'Your box is full' : 'Your box · ' + pct + '% full';
        total.textContent = totalText;
        go.textContent = isFull ? 'Review and add' : 'View box';
        bar.classList.toggle('full', isFull);
      }
    };
  };
})();

(function () {
  'use strict';

  var D = window.DELO || {};
  var fmt;
  try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: D.currency || 'USD' }); }
  catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }

  function money(cents) { return fmt.format(cents / 100); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* Delivery options come from the subscriptions app with names like "Delivery every 2 weeks".
     Show them as Weekly / Every 2 weeks / Monthly, sorted shortest first. */
  var UNIT_DAYS = { day: 1, week: 7, month: 30, year: 365 };
  function parseFreq(name) {
    var m = /(\d+)\s*[- ]?\s*(day|week|month|year)/i.exec(name);
    if (m) return { n: +m[1], unit: m[2].toLowerCase() };
    var u = /(day|week|month|year)/i.exec(name);
    if (!u) return null;
    return { n: /bi-?week|fortnight/i.test(name) ? 2 : 1, unit: u[1].toLowerCase() };
  }
  function niceLabel(name) {
    var f = parseFreq(name);
    if (!f) return name;
    if (f.n === 1) return { day: 'Daily', week: 'Weekly', month: 'Monthly', year: 'Yearly' }[f.unit];
    return 'Every ' + f.n + ' ' + f.unit + 's';
  }
  function freqDays(name) { var f = parseFreq(name); return f ? f.n * UNIT_DAYS[f.unit] : 9999; }
  function sortFreqs(names) { return names.slice().sort(function (a, b) { return freqDays(a) - freqDays(b); }); }
  /* Pick the delivery option to show first: every 2 weeks when it exists. */
  function defaultFreq(names) {
    for (var i = 0; i < names.length; i++) { if (niceLabel(names[i]) === 'Every 2 weeks') return names[i]; }
    return names[0] || null;
  }
  function freqNote(name) {
    if (!name) return '';
    var l = niceLabel(name);
    return 'Delivered ' + l.charAt(0).toLowerCase() + l.slice(1) + '.';
  }

  /* ---------- flavor cards: size switch ---------- */
  $$('[data-card]').forEach(function (card) {
    var img = $('[data-card-img]', card);
    var price = $('[data-card-price]', card);
    var size = $('[data-card-size]', card);
    var add = $('[data-card-add]', card);
    function update() {
      var r = $('input[name=id]:checked', card);
      if (!r) return;
      if (price) price.textContent = r.dataset.price;
      if (size) size.textContent = r.dataset.label;
      var snack = r.dataset.snack === 'true';
      var src = snack ? (card.dataset.snackSrc || r.dataset.image || '') : (card.dataset.bagSrc || '');
      if (img && src) { img.src = src; img.classList.toggle('snack', snack); }
      var ok = r.dataset.available === 'true';
      if (add) { add.disabled = !ok; add.textContent = ok ? 'Add to cart' : 'Sold out'; }
    }
    $$('input[name=id]', card).forEach(function (r) { r.addEventListener('change', update); });
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var data = readJSON($('[data-pdp-json]', root));
    var form = $('form', root);
    if (!data || !form) return;
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    var priceEl = $('[data-pdp-price]', root);
    var addBtn = $('[data-pdp-add]', root);
    var imgEl = $('[data-pdp-img]', root);
    var box = $('[data-pdp-buyopt]', root);
    var planInput = $('[data-pdp-plan]', root);
    var freqWrap = $('[data-pdp-freq]', root);

    var names = [];
    data.variants.forEach(function (v) {
      v.plans.forEach(function (p) { if (names.indexOf(p.name) === -1) names.push(p.name); });
    });
    names = sortFreqs(names);
    var sub = false;
    var freq = defaultFreq(names);

    if (box && names.length === 0) { box.hidden = true; box = null; }
    if (box && freqWrap) {
      names.forEach(function (n) {
        var label = document.createElement('label');
        label.innerHTML = '<input type="radio" name="pdpfreq"' + (n === freq ? ' checked' : '') + ' value="' + esc(n) + '"><span>' + esc(niceLabel(n)) + '</span>';
        freqWrap.appendChild(label);
      });
    }

    function current() {
      var r = $('input[name=id]:checked', form) || $('input[name=id]', form);
      return byId[r.value];
    }
    function planFor(v) {
      var found = null;
      v.plans.forEach(function (p) { if (p.name === freq) found = p; });
      return found || v.plans[0] || null;
    }
    function update() {
      var v = current();
      if (!v) return;
      var plan = planFor(v);
      if (sub && !plan) sub = false;
      if (priceEl) priceEl.textContent = money(sub && plan ? plan.price : v.price);
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.image && imgEl) imgEl.src = v.image;
      if (!box) return;

      var pct = plan && v.price > 0 ? Math.round((1 - plan.price / v.price) * 100) : 0;
      var subRow = $('input[value=sub]', box).closest('label');
      subRow.hidden = !plan;
      $('[data-pdp-once]', root).textContent = money(v.price);
      if (plan) {
        $('[data-pdp-sub-title]', root).textContent = pct > 0 ? 'Subscribe and save ' + pct + '%' : 'Subscribe';
        $('[data-pdp-was]', root).textContent = pct > 0 ? money(v.price) : '';
        $('[data-pdp-sub-price]', root).textContent = money(plan.price);
        $('[data-pdp-save]', root).textContent = pct > 0 ? 'Save ' + money(v.price - plan.price) + ' on every delivery' : '';
      }
      freqWrap.hidden = !sub;
      $('[data-pdp-subnote]', root).hidden = !sub;
      $('[data-pdp-freq-note]', root).textContent = freqNote(freq);
      planInput.disabled = !(sub && plan);
      planInput.value = sub && plan ? plan.id : '';
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'purchase') sub = t.value === 'sub';
      if (t.name === 'pdpfreq') freq = t.value;
      update();
    });
    $$('[data-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () { if (imgEl) imgEl.src = b.dataset.thumb; });
    });
    update();
  });

  /* ---------- build a box: bags and snacks together ---------- */
  /* A box fits N bags or M snacks. Sizes are scaled so a bag and a snack are whole numbers
     (6 bags / 20 snacks becomes 60 parts: a bag takes 10, a snack takes 3). The box counts
     as full once no snack (the smallest item) fits any more. */
  function gcd(a, b) { return b ? gcd(b, a % b) : a; }

  $$('[data-box]').forEach(function (root) {
    var data = readJSON($('[data-box-json]', root));
    if (!data) return;
    var products = data.products.filter(function (p) { return p.bag || p.snack; });

    var el = {
      pick: $('[data-box-pick]', root), contents: $('[data-box-contents]', root),
      count: $('[data-box-count]', root), total: $('[data-box-total]', root),
      discRow: $('[data-box-disc-row]', root), discLabel: $('[data-box-disc-label]', root), disc: $('[data-box-disc]', root),
      bar: $('[data-box-bar]', root), msg: $('[data-box-msg]', root), add: $('[data-box-add]', root),
      clear: $('[data-box-clear]', root), even: $('[data-box-even]', root),
      optSub: $('[data-opt-sub]', root), freqWrap: $('[data-box-freq]', root), subNote: $('[data-box-subnote]', root),
      freqNote: $('[data-freq-note]', root), subTitle: $('[data-sub-title]', root), was: $('[data-price-was]', root),
      priceSub: $('[data-price-sub]', root), priceOnce: $('[data-price-once]', root), subSave: $('[data-sub-save]', root)
    };

    var hasKind = {
      bag: products.some(function (p) { return p.bag; }),
      snack: products.some(function (p) { return p.snack; })
    };
    if (!hasKind.bag && !hasKind.snack) {
      el.msg.textContent = 'Add your popcorn to the "All popcorn" collection and the box builder will appear here.';
      el.add.hidden = true; el.clear.hidden = true; el.even.hidden = true;
      return;
    }

    var g = gcd(data.bagsPerBox, data.snacksPerBox);
    var TAKES = { bag: data.snacksPerBox / g, snack: data.bagsPerBox / g };
    var CAP = data.bagsPerBox * data.snacksPerBox / g;
    var smallest = Math.min(hasKind.bag ? TAKES.bag : 9999, hasKind.snack ? TAKES.snack : 9999);
    var LABEL = { bag: '4.2 oz bag', snack: '1.2 oz snack' };
    var KINDS = ['bag', 'snack'];

    var qty = products.map(function () { return { bag: 0, snack: 0 }; });
    var sub = false;

    var names = [];
    products.forEach(function (p) {
      KINDS.forEach(function (k) {
        if (p[k]) p[k].plans.forEach(function (pl) { if (names.indexOf(pl.name) === -1) names.push(pl.name); });
      });
    });
    names = sortFreqs(names);
    var freq = defaultFreq(names);
    if (names.length === 0) { el.optSub.hidden = true; }
    else {
      names.forEach(function (n) {
        var label = document.createElement('label');
        label.innerHTML = '<input type="radio" name="boxfreq-' + root.id + '"' + (n === freq ? ' checked' : '') + ' value="' + esc(n) + '"><span>' + esc(niceLabel(n)) + '</span>';
        el.freqWrap.appendChild(label);
      });
    }

    function planOf(v) {
      var r = null;
      v.plans.forEach(function (pl) { if (pl.name === freq) r = pl; });
      return r;
    }
    function used() {
      var u = 0;
      qty.forEach(function (q) { u += q.bag * TAKES.bag + q.snack * TAKES.snack; });
      return u;
    }
    function imgFor(p, k) { return k === 'snack' ? (p.snackImg || p.bagImg) : (p.bagImg || p.snackImg); }

    function sums() {
      var full = 0, subT = 0, can = true, items = 0;
      products.forEach(function (p, i) {
        KINDS.forEach(function (k) {
          var q = qty[i][k], v = p[k];
          if (!v || q < 1) return;
          items += q;
          full += q * v.price;
          var pl = planOf(v);
          if (!pl) can = false;
          subT += q * (pl ? pl.price : v.price);
        });
      });
      return { full: full, sub: subT, can: can, items: items };
    }

    function buildPick() {
      el.pick.innerHTML = '';
      products.forEach(function (p, i) {
        var row = document.createElement('div');
        row.className = 'pick-row';
        function line(k) {
          var v = p[k];
          if (!v) return '';
          var im = imgFor(p, k);
          return '<div class="pick-line">' + (im ? '<img class="pl-img" src="' + esc(im) + '" alt="" width="54" height="68">' : '<span></span>') +
            '<span class="pl">' + LABEL[k] + '<small>' + money(v.price) + (v.available ? '' : ' · sold out') + '</small></span>' +
            '<div class="stepper"><button type="button" data-i="' + i + '" data-k="' + k + '" data-d="-1" aria-label="Remove one ' + esc(p.title) + ' ' + LABEL[k] + '">−</button>' +
            '<output data-q="' + i + '-' + k + '">0</output>' +
            '<button type="button" data-i="' + i + '" data-k="' + k + '" data-d="1" aria-label="Add one ' + esc(p.title) + ' ' + LABEL[k] + '">+</button></div></div>';
        }
        row.innerHTML = '<div class="pick-main"><b>' + esc(p.title) + '</b>' + line('bag') + line('snack') + '</div>';
        el.pick.appendChild(row);
      });
    }

    var wasFull = false, miniBar = null;
    function render() {
      var u = used(), left = CAP - u, isFull = left < smallest;
      if (isFull && !wasFull && window.deloCelebrate) window.deloCelebrate($('.box-sum', root), (window.DELO || {}).flower);
      wasFull = isFull;
      /* once nothing else fits, the box is as full as it can get, so say 100% */
      var pct = isFull ? 100 : Math.round(u / CAP * 100);
      var s = sums(), shownSub = sub && s.can, tot = shownSub ? s.sub : s.full;

      var html = '';
      products.forEach(function (p, i) {
        KINDS.forEach(function (k) {
          var q = qty[i][k], v = p[k];
          var o = $('[data-q="' + i + '-' + k + '"]', el.pick);
          if (o) o.textContent = q;
          if (v && q > 0) {
            html += '<div class="cl' + (k === 'snack' ? ' snk' : '') + '">' +
              (imgFor(p, k) ? '<img src="' + esc(imgFor(p, k)) + '" alt="">' : '<span></span>') +
              '<span>' + q + ' × ' + esc(p.title) + ' ' + LABEL[k] + '</span><b>' + money(q * v.price) + '</b></div>';
          }
        });
      });
      el.contents.innerHTML = html || '<p class="cl-empty">Nothing in your box yet. Pick bags or snacks on the left.</p>';

      $$('button', el.pick).forEach(function (b) {
        var i = +b.dataset.i, k = b.dataset.k, d = +b.dataset.d, v = products[i][k];
        b.disabled = d < 0 ? qty[i][k] <= 0 : (left < TAKES[k] || !v.available);
      });

      el.count.textContent = 'Box is ' + pct + '% full';
      el.total.textContent = money(tot);
      if (!miniBar && window.deloBoxBar) miniBar = window.deloBoxBar(root, $('.box-sum', root));
      if (miniBar) miniBar.update(pct, money(tot), isFull);

      /* reference prices for the purchase options: the current box, or a full box of bags */
      var ref = null;
      products.forEach(function (p) { if (!ref && p.bag) ref = p.bag; });
      var refFull = s.full > 0 ? s.full : (ref ? data.bagsPerBox * ref.price : 0);
      var refSub = refFull;
      var pct15 = data.fallbackPct;
      if (s.full > 0 && s.can) { refSub = s.sub; }
      else if (ref) { var pl0 = planOf(ref); if (pl0) refSub = data.bagsPerBox * pl0.price; }
      if (refFull > 0 && refSub < refFull) pct15 = Math.round((1 - refSub / refFull) * 100);
      else if (refFull > 0) pct15 = 0;
      el.priceOnce.textContent = money(refFull);
      el.priceSub.textContent = money(refSub);
      el.was.textContent = pct15 > 0 ? money(refFull) : '';
      el.subTitle.textContent = pct15 > 0 ? 'Subscribe and save ' + pct15 + '%' : 'Subscribe';
      el.subSave.textContent = pct15 > 0 ? 'Save ' + money(refFull - refSub) + ' on every box · free shipping' : 'Free shipping on every box';

      el.discRow.hidden = !shownSub;
      el.disc.textContent = '−' + money(s.full - s.sub);
      el.discLabel.textContent = 'Subscribe and save' + (pct15 > 0 ? ' ' + pct15 + '%' : '');
      el.freqWrap.hidden = !sub;
      el.subNote.hidden = !sub;
      el.freqNote.textContent = freqNote(freq);

      el.bar.style.width = pct + '%';
      el.msg.classList.toggle('done', isFull);
      if (isFull) {
        el.msg.textContent = shownSub
          ? 'Your box is full. You save ' + money(s.full - s.sub) + ' on every delivery and it ships free.'
          : 'Your box is full and ships free.';
      } else {
        var rb = hasKind.bag ? Math.floor(left / TAKES.bag) : 0, rs = hasKind.snack ? Math.floor(left / TAKES.snack) : 0;
        var parts = [];
        if (rb > 0) parts.push(rb + ' more ' + (rb === 1 ? 'bag' : 'bags'));
        if (rs > 0) parts.push(rs + ' more ' + (rs === 1 ? 'snack' : 'snacks'));
        el.msg.textContent = 'Room for ' + parts.join(' or ') + '. Fill your box to ship free.';
      }
      if (sub && !s.can && s.items > 0) el.msg.textContent = 'That delivery option is not available for every flavor in your box.';
      el.add.disabled = !isFull || (sub && !s.can);
      el.add.textContent = isFull ? (sub ? 'Start subscription · ' : 'Add box to cart · ') + money(tot) : 'Fill your box · ' + pct + '% full';
    }

    $$('input[name^=buyopt]', root).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { sub = r.value === 'sub'; render(); } });
    });
    el.freqWrap.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('boxfreq') === 0) { freq = e.target.value; render(); }
    });
    el.pick.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled) return;
      var i = +b.dataset.i, k = b.dataset.k, d = +b.dataset.d;
      if (d > 0 && CAP - used() < TAKES[k]) return;
      qty[i][k] = Math.max(0, qty[i][k] + d);
      render();
    });
    el.even.addEventListener('click', function () {
      function lowest(k) {
        var pool = products.map(function (p, i) { return i; }).filter(function (i) { return products[i][k] && products[i][k].available; });
        pool.sort(function (a, b) { return qty[a][k] - qty[b][k]; });
        return pool[0];
      }
      var guard = 0, i;
      if (hasKind.bag) {
        while (CAP - used() >= TAKES.bag && guard++ < 300) { i = lowest('bag'); if (i === undefined) break; qty[i].bag += 1; }
      }
      if (hasKind.snack) {
        while (CAP - used() >= TAKES.snack && guard++ < 600) { i = lowest('snack'); if (i === undefined) break; qty[i].snack += 1; }
      }
      render();
    });
    el.clear.addEventListener('click', function () { qty = products.map(function () { return { bag: 0, snack: 0 }; }); render(); });

    el.add.addEventListener('click', function () {
      if (CAP - used() >= smallest) return;
      var items = [];
      products.forEach(function (p, i) {
        KINDS.forEach(function (k) {
          var q = qty[i][k], v = p[k];
          if (!v || q < 1) return;
          var item = { id: v.id, quantity: q, properties: { _box: data.box } };
          if (sub) {
            var pl = planOf(v);
            if (!pl) return;
            item.selling_plan = pl.id;
          }
          items.push(item);
        });
      });
      el.add.disabled = true;
      el.add.textContent = 'Adding…';
      fetch((D.addUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (j) { return { ok: res.ok, body: j }; });
      }).then(function (r) {
        if (r.ok) { window.location.href = D.cartUrl || '/cart'; return; }
        el.msg.textContent = (r.body && (r.body.description || r.body.message)) || 'Something went wrong adding your box. Please try again.';
        render();
      }).catch(function () {
        el.msg.textContent = 'Something went wrong adding your box. Please try again.';
        render();
      });
    });

    buildPick();
    render();
  });

  /* ---------- copy email ---------- */
  $$('[data-copy-mail]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var addr = $('[data-mail-addr]');
      if (!addr) return;
      function done(t) { btn.textContent = t; setTimeout(function () { btn.textContent = 'Copy'; }, 1400); }
      function select() {
        var r = document.createRange(); r.selectNodeContents(addr);
        var g = window.getSelection(); g.removeAllRanges(); g.addRange(r); done('Selected');
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(addr.textContent.trim()).then(function () { done('Copied'); }, select);
      } else { select(); }
    });
  });
})();

/* kettle: the whole illustration drifts and hops as you scroll, and your loose popcorn pieces pop out and bounce back */
(function () {
  var stage = document.querySelector('.story .pot-stage');
  if (!stage || !window.requestAnimationFrame) return;
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;
  var pops = [
    { el: stage.querySelector('[data-pop=a]'), dx: 38, dy: -78, rot: 26, per: 70, ph: 0.0 },
    { el: stage.querySelector('[data-pop=b]'), dx: -52, dy: -64, rot: -30, per: 85, ph: 0.35 },
    { el: stage.querySelector('[data-pop=c]'), dx: -30, dy: -90, rot: 22, per: 95, ph: 0.7 }
  ].filter(function (n) { return n.el; });
  var ticking = false, idle = null;
  function update() {
    ticking = false;
    var r = stage.getBoundingClientRect(), vh = window.innerHeight || 800;
    if (r.bottom < -100 || r.top > vh + 100) return;
    var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
    p = Math.max(-1, Math.min(1, p));
    var y = window.pageYOffset || 0, wob = Math.sin(y / 16), hop = Math.abs(Math.sin(y / 22));
    var ty = p * 28 - hop * 9, rot = p * -4 + wob * 2.2, sc = 1 + hop * 0.02;
    stage.classList.remove('settle');
    stage.style.transform = 'translateY(' + ty.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ', ' + (2 - sc).toFixed(3) + ')';
    var k = r.width / 520;
    pops.forEach(function (n) {
      var t = Math.abs(Math.sin(y / n.per + n.ph * 3.14)), s = Math.sin(y / (n.per * 1.7) + n.ph * 6);
      n.el.style.transform = 'translate(' + (n.dx * t * k).toFixed(1) + 'px,' + (n.dy * t * k).toFixed(1) + 'px) rotate(' + (n.rot * s).toFixed(1) + 'deg)';
    });
    clearTimeout(idle);
    idle = setTimeout(function () {
      stage.classList.add('settle');
      pops.forEach(function (n) { n.el.style.transform = ''; });
    }, 160);
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* rolling smile: each .roll rolls in from the left edge when it scrolls into view; tap it to roll again */
(function () {
  var rolls = document.querySelectorAll('.roll');
  if (!rolls.length) return;
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;
  rolls.forEach(function (el) {
    if (!el.animate) return;
    var R = Math.max(el.getBoundingClientRect().width, 54) / 2, rolling = false, started = false;
    function roll() {
      if (rolling) return;
      rolling = true;
      var box = el.getBoundingClientRect(), d = box.left + box.width + 40, deg = d / R * 180 / Math.PI;
      var a = el.animate([
        { transform: 'translateX(' + (-d) + 'px) rotate(' + (-deg) + 'deg)', offset: 0 },
        { transform: 'translateX(9px) rotate(9deg)', offset: 0.86 },
        { transform: 'translateX(-3px) rotate(-4deg)', offset: 0.94 },
        { transform: 'translateX(0) rotate(0deg)', offset: 1 }
      ], { duration: 1700, easing: 'cubic-bezier(.25,.6,.35,1)' });
      a.onfinish = a.oncancel = function () { rolling = false; };
    }
    function go() { if (started) return; started = true; el.style.visibility = ''; roll(); }
    el.style.visibility = 'hidden';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { go(); io.disconnect(); } }, { threshold: 0.6 });
      io.observe(el);
    } else { go(); }
    el.addEventListener('click', roll);
  });
})();

/* celebration: when a box becomes 100% full, the smile rolls across it once */
(function () {
  window.deloCelebrate = function (box, src) {
    if (!box || !src || !box.animate) return;
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq && mq.matches) return;
    var layer = document.createElement('div');
    layer.className = 'celebrate';
    layer.setAttribute('aria-hidden', 'true');
    var im = document.createElement('img');
    im.src = src; im.alt = ''; im.width = 56; im.height = 56;
    layer.appendChild(im);
    box.appendChild(layer);
    var w = box.clientWidth, deg = (w + 112) / 28 * 180 / Math.PI;
    var a = im.animate([
      { transform: 'translateX(-60px) rotate(0deg)' },
      { transform: 'translateX(' + (w + 4) + 'px) rotate(' + deg + 'deg)' }
    ], { duration: 1600, easing: 'cubic-bezier(.35,.1,.5,1)' });
    a.onfinish = a.oncancel = function () { if (layer.parentNode) layer.parentNode.removeChild(layer); };
  };
})();

/* ---- where we ship + find us ---- */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var map = document.querySelector('.sm-map');
  if (map) {
    if (reduce || !('IntersectionObserver' in window)) { map.classList.add('seen'); }
    else {
      document.documentElement.classList.add('js');
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { map.classList.add('seen'); io.disconnect(); }
      }, { threshold: 0.3 });
      io.observe(map);
    }
  }
  var fu = document.querySelector('.findus');
  if (!fu) return;
  var tabs = fu.querySelectorAll('.fu-tabs button'), pins = fu.querySelectorAll('.pin'), regs = fu.querySelectorAll('.reg');
  function show(area) {
    tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.area === area ? 'true' : 'false'); });
    fu.querySelectorAll('.fu-places').forEach(function (p) { p.hidden = p.id !== 'fu-' + area; });
    pins.forEach(function (p) { p.classList.toggle('on', p.dataset.area === area); p.classList.remove('hot'); });
    regs.forEach(function (r) { r.classList.toggle('on', r.dataset.area === area); });
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.area); }); });
  fu.querySelectorAll('.fu-places li').forEach(function (li) {
    function hot(on) { var k = li.dataset.town; if (!k) return; pins.forEach(function (p) { if (p.dataset.town === k) p.classList.toggle('hot', on); }); }
    li.addEventListener('mouseenter', function () { hot(true); });
    li.addEventListener('mouseleave', function () { hot(false); });
  });
  show('boise');
})();
